import { RootState } from "@/store/store";
import { formatBillingExplorerSummaryDataGettingPayload } from "@/store/explain-with-ai/selectors/utils/helpers";
import { addFilterTreePathToResourceExplorerPayload } from "@/store/resource-explorer/utils/helpers/path/addFilterTreePathToResourceExplorerPayload";
import { resourceExplorerPayloadDataSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/resource-explorer-widget/resourceExplorerPayloadDataSelector";
import { explainWithAIModeSelector } from "@/store/explain-with-ai/selectors/slice-data/explainWithAIModeSelector";

export const getBillingExplorerSummaryFixedCashKeySelector = (
  state: RootState,
): string | undefined => {
  const resourceExplorerDataGettingPayload =
    resourceExplorerPayloadDataSelector(state);
  const payload = addFilterTreePathToResourceExplorerPayload(
    resourceExplorerDataGettingPayload,
  );
  const mode = explainWithAIModeSelector(state) ?? "";

  return (
    JSON.stringify(formatBillingExplorerSummaryDataGettingPayload(payload)) +
    mode
  );
};
